var path = '/var/www/mmscny-website/src/app/common/components/print-screen/print-screen.html';
var html = "<div class=print-screen ng-click=$ctrl.printScreen() ng-if=\"$ctrl.type !== 'button'\" aria-label=\"Print the details\"> <img src=/./images/icon-printer.png /> </div> <div class=skew-button ng-click=$ctrl.printScreen() ng-if=\"$ctrl.type === 'button'\" aria-label=\"Print the details\"> <div class=skew-btn-submit> <input type=button value=print class=btn-submit> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/print-screen/print-screen.html
// module id = 656
// module chunks = 0